import React, { useEffect, useMemo, useState } from 'react'
import { Modal, Text, Flex, Box, Button, Skeleton , Link,Image, useMatchBreakpoints} from '@pancakeswap/uikit'
import { getBalanceNumber } from 'utils/formatBalance'
import useTheme from 'hooks/useTheme'
import { useTranslation } from 'contexts/Localization'
import { usePriceCakeBusd , usePriceHVIBusd,usePricebeethBusd, usePriceLGCBusd, usePriceBnbBusd,usePriceliraBusd, usePriceLameaBusd, usePriceBVCBusd, usePriceBABYVIZSLABusd, usePriceETCBusd, usePriceATALIRABusd, usePriceEXZOBusd, usePricebabyBusd, usePriceLTCBusd, usePricecubyBusd } from 'state/farms/hooks'
import {  getHVIAddress ,getbeethAddress, getCakeAddress, getWbnbAddress , getFarm1Address, getlgcAddress, getFarm2Address,getFarm4Address,getFarm5Address, getBusdAddress, getFarm3Address, getFarm6Address , getFarm7Address, getbvcAddress, getFarm9Address, getbabyvizslaAddress, getFarm10Address, getFarm19Address, getbabyAddress, getFarm27Address, getFarm29Address} from 'utils/addressHelpers'
import {  useFarm1,useFarm29,useTotalSupplyFarm1 , useMaster1 , useFarm2 ,useFarm3,useFarm4, useTotalSupplyFarm2, useTotalSupplyFarm3, useTotalSupplyFarm4, useFarm5, useTotalSupplyFarm5, useFarm6 , useTotalSupplyFarm6 , useFarm7 , useTotalSupplyFarm7, useFarm9, useTotalSupplyFarm9 , useFarm10, useTotalSupplyFarm10 , useFarm19, useTotalSupplyFarm19, useFarm27, useTotalSupplyFarm27, usePool5, usePool4, usePool6 , usePool11, usePool13, usePool14, usePool15, usePool17, usePool22, usePool23, usePool26, usePool28, usePool29, usePool38, usePool42, usePool43, usePool44,  usePool1, usePool3, usePool4b, usePool4c, usePool4d, useTotalSupplyFarm29, useLocked, useLocked2, useLocked3 , usePool56, usePool57,usePool58} from 'hooks/useTokenBalance'
import Balance from 'components/Balance'
import { createClient } from '@supabase/supabase-js';
import FarmsPoolsRowLoader from '../Home/components/FarmsPoolsRowLoader'
import { ButtonPro, ButtonText, Container, HeadingText, ImageWrapper, SalesSectionProps, ScrollBox, SubHeadingText, Word } from './Styled'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;
const supabase = createClient(supabaseUrl, supabaseKey);

const SalesSection: React.FC<SalesSectionProps> = (props) => {
  const { t } = useTranslation()
  const { theme } = useTheme()
  const [allin2, setAllin2] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const bnbprice = usePriceBnbBusd().toNumber()
  const cakePriceBusd = usePriceCakeBusd()
  const vizslaprice = cakePriceBusd.toNumber()
  const hviprice0 = usePriceHVIBusd()
  const hviprice = hviprice0.toNumber()
  const lgcprice0 = usePriceLGCBusd()
  const lgcprice = lgcprice0.toNumber()
  const bvcprice0 = usePriceBVCBusd()
  const bvcprice = bvcprice0.toNumber()
  const babyvizslaprice0 = usePriceBABYVIZSLABusd()
  const babyvizslaprice = babyvizslaprice0.toNumber()
  const babyprice0 = usePricebabyBusd()
  const babyprice = babyprice0.toNumber()
  const beethprice0 = usePricebeethBusd()
  const beethprice = beethprice0.toNumber()
  // farm 1
    const vizslalpbalance = getBalanceNumber(useFarm1(getCakeAddress()))
    const bnblpbalance = getBalanceNumber(useFarm1(getWbnbAddress()))
    const kombo1 = useTotalSupplyFarm1()
    const kombo2 = kombo1 ? getBalanceNumber(kombo1) : 0
    const teljes = vizslaprice * vizslalpbalance 
    const teljes2 = bnbprice * bnblpbalance
    const teljes3 = teljes + teljes2
    const minden = teljes3 / kombo2  
    const masterfarm1 = getBalanceNumber(useMaster1(getFarm1Address()))
    const farm1 = minden * masterfarm1
    // farm 2 
    const vizslalpbalance2 = getBalanceNumber(useFarm2(getCakeAddress()))
    const bnblpbalance2 = getBalanceNumber(useFarm2(getWbnbAddress()))
    const kombo3 = useTotalSupplyFarm2()
    const kombo4 = kombo3 ? getBalanceNumber(kombo3) : 0
    const teljes4 = vizslaprice * vizslalpbalance2 
    const teljes5 = bnbprice * bnblpbalance2
    const teljes6 = teljes4 + teljes5
    const minden1 = teljes6 / kombo4
    const masterfarm2 = getBalanceNumber(useMaster1(getFarm2Address()))
    const farm2 = minden1 * masterfarm2
  // farm 3
    const vizslalpbalance3 = getBalanceNumber(useFarm3(getCakeAddress()))
    const busdlpbalance = getBalanceNumber(useFarm3(getBusdAddress()))
    const kombo5 = useTotalSupplyFarm3()
    const kombo6 = kombo5 ? getBalanceNumber(kombo5) : 0
    const teljes7 = vizslaprice * vizslalpbalance3 
    const teljes8 = 1 * busdlpbalance
    const teljes9 = teljes7 + teljes8
    const minden2 = teljes9 / kombo6
    const masterfarm3 = getBalanceNumber(useMaster1(getFarm3Address()))
    const farm3 = minden2 * masterfarm3
    // farm 4
    const vizslalpbalance4 = getBalanceNumber(useFarm4(getCakeAddress()))
    const busdlpbalance2 = getBalanceNumber(useFarm4(getBusdAddress()))
    const kombo7 = useTotalSupplyFarm4()
    const kombo8 = kombo7 ? getBalanceNumber(kombo7) : 0
    const teljes10 = vizslaprice * vizslalpbalance4
    const teljes11 = 1 * busdlpbalance2
    const teljes12 = teljes10 + teljes11
    const minden3 = teljes12 / kombo8
    const masterfarm4 = getBalanceNumber(useMaster1(getFarm4Address()))
    const farm4 = minden3 * masterfarm4
      // farm 5
      const hvilpbalance = getBalanceNumber(useFarm5(getHVIAddress()))
      const bnblpbalance3 = getBalanceNumber(useFarm5(getWbnbAddress()))
      const kombo9 = useTotalSupplyFarm5()
      const kombo10 = kombo9 ? getBalanceNumber(kombo9) : 0
      const teljes13 = hviprice * hvilpbalance
      const teljes14 = bnbprice * bnblpbalance3
      const teljes15 = teljes13 + teljes14
      const minden4 = teljes15 / kombo10
      const masterfarm5 = getBalanceNumber(useMaster1(getFarm5Address()))
      const farm5 = minden4 * masterfarm5 * 2
      // farm 6
      const hvilpbalance2 = getBalanceNumber(useFarm6(getHVIAddress()))
      const busdlpbalance3 = getBalanceNumber(useFarm6(getBusdAddress()))
      const kombo11 = useTotalSupplyFarm6()
      const kombo12 = kombo11 ? getBalanceNumber(kombo11) : 0
      const teljes16 = hviprice * hvilpbalance2
      const teljes17 = 1 * busdlpbalance3
      const teljes18 = teljes16 + teljes17
      const minden5 = teljes18 / kombo12
      const masterfarm6 = getBalanceNumber(useMaster1(getFarm6Address()))
      const farm6 = minden5 * masterfarm6 * 2
  // farm 7
      const hvilpbalance3 = getBalanceNumber(useFarm7(getHVIAddress()))
      const vizslalpbalance5 = getBalanceNumber(useFarm7(getCakeAddress()))
      const kombo13 = useTotalSupplyFarm7()
      const kombo14 = kombo13 ? getBalanceNumber(kombo13) : 0
      const teljes19 = hviprice * hvilpbalance3
      const teljes20 = vizslaprice * vizslalpbalance5
      const teljes21 = teljes19 + teljes20
      const minden6 = teljes21 / kombo14
      const masterfarm7 = getBalanceNumber(useMaster1(getFarm7Address()))
      const farm7 = minden6 * masterfarm7 * 2
  // farm 9
  const bvclpbalance = getBalanceNumber(useFarm9(getbvcAddress()))
  const vizslalpbalance7 = getBalanceNumber(useFarm9(getCakeAddress()))
  const kombo17 = useTotalSupplyFarm9()
  const kombo18 = kombo17 ? getBalanceNumber(kombo17) : 0
  const teljes25 = bvcprice * bvclpbalance
  const teljes26 = vizslaprice * vizslalpbalance7
  const teljes27 = teljes25 + teljes26
  const minden8 = teljes27 / kombo18
  const masterfarm9 = getBalanceNumber(useMaster1(getFarm9Address()))
  const farm9 = minden8 * masterfarm9
  // farm 10
  const babylpbalance = getBalanceNumber(useFarm10(getbabyvizslaAddress()))
  const vizslalpbalance8 = getBalanceNumber(useFarm10(getCakeAddress()))
  const kombo19 = useTotalSupplyFarm10()
  const kombo20 = kombo19 ? getBalanceNumber(kombo19) : 0
  const teljes28 = babyvizslaprice * babylpbalance
  const teljes29 = vizslaprice * vizslalpbalance8
  const teljes30 = teljes28 + teljes29
  const minden9 = teljes30 / kombo20
  const masterfarm10 = getBalanceNumber(useMaster1(getFarm10Address()))
  const farm10 = minden9 * masterfarm10
  // farm 19
  const bnblpbalance6 = getBalanceNumber(useFarm19(getWbnbAddress()))
  const babyvizslalpbalance = getBalanceNumber(useFarm19(getbabyvizslaAddress()))
  const kombo37 = useTotalSupplyFarm19()
  const kombo38 = kombo37 ? getBalanceNumber(kombo37) : 0
  const teljes55 = babyvizslaprice * babyvizslalpbalance
  const teljes56 = bnbprice * bnblpbalance6
  const teljes57 = teljes55 + teljes56
  const minden18 = teljes57 / kombo38
  const masterfarm19 = getBalanceNumber(useMaster1(getFarm19Address()))
  const farm19 = minden18 * masterfarm19
// farm 25
const vizslalpbalance20 = getBalanceNumber(useFarm27(getCakeAddress()))
const babybalance2 = getBalanceNumber(useFarm27(getbabyAddress()))
const kombo51 = useTotalSupplyFarm27()
const kombo52 = kombo51 ? getBalanceNumber(kombo51) : 0
const teljes76 = vizslaprice * vizslalpbalance20
const teljes77 = babyprice * babybalance2
const teljes78 = teljes76 + teljes77
const minden25 = teljes78 / kombo52
const masterfarm26 = getBalanceNumber(useMaster1(getFarm27Address()))
const farm26 = minden25 * masterfarm26
// farm 27
const vizslalpbalance22 = getBalanceNumber(useFarm29(getCakeAddress()))
const beethbalance = getBalanceNumber(useFarm29(getbeethAddress()))
const kombo55 = useTotalSupplyFarm29()
const kombo56 = kombo55 ? getBalanceNumber(kombo55) : 0
const teljes82 = vizslaprice * vizslalpbalance22
const teljes83 = beethprice * beethbalance
const teljes84 = teljes82 + teljes83
const minden27 = teljes84 / kombo56
const masterfarm28 = getBalanceNumber(useMaster1(getFarm29Address()))
const farm28 = minden27 * masterfarm28
  // minden farm 
   const farmminden =  farm1 + farm2 + farm3 + farm4 + farm5 + farm6 + farm7 + farm9 + farm10   + farm19  + farm26  + farm28
   const POOL4 = getBalanceNumber(usePool4(getCakeAddress()))
   const POOL5 = getBalanceNumber(usePool5(getCakeAddress()))
   const POOL6 = getBalanceNumber(usePool6(getCakeAddress()))
   const POOL11 = getBalanceNumber(usePool11(getCakeAddress()))
   const POOL13 = getBalanceNumber(usePool13(getCakeAddress()))
   const POOL14 = getBalanceNumber(usePool14(getCakeAddress()))
   const POOL15 = getBalanceNumber(usePool15(getCakeAddress()))
   const POOL17 = getBalanceNumber(usePool17(getCakeAddress()))
   const POOL22 = getBalanceNumber(usePool22(getHVIAddress()))
   const POOL23 = getBalanceNumber(usePool23(getHVIAddress()))
   const POOL26 = getBalanceNumber(usePool26(getHVIAddress()))
   const POOL28 = getBalanceNumber(usePool28(getHVIAddress()))
   const POOL29 = getBalanceNumber(usePool29(getHVIAddress()))
   const POOL38 = getBalanceNumber(usePool38(getbabyvizslaAddress()))
   const POOL42 = getBalanceNumber(usePool42(getlgcAddress()))
   const POOL43 = getBalanceNumber(usePool43(getCakeAddress()))
   const POOL44 = getBalanceNumber(usePool44(getHVIAddress()))
   const POOL56 = getBalanceNumber(usePool56(getbeethAddress()))
   const POOL57 = getBalanceNumber(usePool57(getCakeAddress()))
   const POOL58 = getBalanceNumber(usePool58(getHVIAddress()))
   const MAJDNEM  = POOL4 + POOL5  + POOL6  + POOL57 + POOL11  + POOL13 + POOL14 + POOL15  + POOL17 + POOL43 
   const MAJDNEM2 = POOL22 + POOL23  + POOL26  + POOL28 + POOL29  + POOL44  + POOL58
   const MAJDNEM3 = POOL42  
   const FULL1 = MAJDNEM * vizslaprice
   const FULL2 = MAJDNEM2 * hviprice * 1000000000
   const FULL12 = POOL38 * babyvizslaprice
   const FULL14 = MAJDNEM3 * lgcprice
   const FULL18 = POOL56 * beethprice
   const FULL3 = FULL1 + FULL2 + FULL12 + FULL14 + FULL18
   // BE2MINING
   const POOL1 = getBalanceNumber(usePool1(getCakeAddress()))
   const POOL3 = getBalanceNumber(usePool3(getCakeAddress()))
   const POOL4b = getBalanceNumber(usePool4b(getCakeAddress()))
   const POOL4c = getBalanceNumber(usePool4c(getCakeAddress()))
   const POOL4d = getBalanceNumber(usePool4d(getCakeAddress()))
   const VÉGE = POOL1  + POOL3  + POOL4b + POOL4c + POOL4d
   const VÉGE1 = VÉGE * vizslaprice
// LOCKED
    const LOCKED = getBalanceNumber(useLocked(getCakeAddress()))
    const LOCKED2 = getBalanceNumber(useLocked3(getCakeAddress()))
    const LOCKED3 = getBalanceNumber(useLocked2(getHVIAddress()))
    const LOCKED4 = LOCKED3 * hviprice * 1000000000
    const LOCKEDFULL2 = LOCKED2 * vizslaprice 
     const LOCKEDFULL = LOCKED * vizslaprice
   const LOCKEDMAXIMUM = LOCKEDFULL + LOCKEDFULL2 + LOCKED4

   useEffect(() => {
    const checkAndUpdateAllin2 = async () => {
      console.log({ VÉGE1, FULL3, farmminden, LOCKEDMAXIMUM }); // Ellenőrizd az értékeket
      if (VÉGE1 && FULL3 && farmminden && LOCKEDMAXIMUM) {
        const newAllin2 = VÉGE1 + FULL3 + farmminden + LOCKEDMAXIMUM
        console.log('Calculated allin2:', newAllin2); // Ellenőrizd, hogy megkapod-e az értéket
        setAllin2(newAllin2)
  
        // Frissítés Supabase-ben
        if (newAllin2 !== null && !Number.isNaN(newAllin2)) {
          await uploadAllin2ToSupabase(newAllin2)
        }
      }
    }
  
    checkAndUpdateAllin2()
  }, [VÉGE1, FULL3, farmminden, LOCKEDMAXIMUM])
  
  
  const uploadAllin2ToSupabase = async (newAllin2) => {
    if (newAllin2 !== null && !Number.isNaN(newAllin2)) {
      const { error } = await supabase
        .from('allin_data')
        .insert([{ allin_value: newAllin2 }])

      if (error) {
        console.error('Error uploading allin2 to Supabase:', error)
      }
    }
  }


  return (
    <Container>
   <Flex flexDirection="column" alignItems="left" >
    <Text color="primary"  fontSize="13px" mr="5px">
        {t('Total Value Locked')}
      </Text>
      <FarmsPoolsRowLoader  />
      {VÉGE1 ? (
        <Balance fontSize="18px" prefix="$" bold decimals={0} value={VÉGE1} />
      ) : (
        <Skeleton width={60} height={16} />
      )}
        {FULL3 ? (
        <Balance fontSize="18px" prefix="$" bold decimals={0} value={FULL3} />
      ) : (
        <Skeleton width={60} height={16} />
      )}
     {farmminden ? (
        <Balance fontSize="18px" prefix="$" bold decimals={0} value={farmminden} />
      ) : (
        <Skeleton width={60} height={16} />
      )}

    </Flex >
 
          <Flex flexDirection="column" alignItems="left" >
    <Text color="primary"  fontSize="13px" mr="5px">
        {t('Total Value Locked')}
      </Text>
      <FarmsPoolsRowLoader  />
      {allin2 ? (
        <Balance fontSize="18px" prefix="$" bold decimals={0} value={allin2} />
      ) : (
        <Skeleton width={60} height={16} />
      )}

    </Flex >
 
          </Container>
  )
}
export default SalesSection


